import React from "react";
import Table from "react-bootstrap/Table";
import Metric from "utils/Metric";

class PPCSummaryDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTable: "ecommerce",
    };
  }

  render() {
    const clients = Object.keys(this.props.metrics);
    const firstKey = clients[0];
    const metrics = Object.keys(this.props.metrics[firstKey]).filter((el) => !el.includes("yy"));
    const leadgenList = this.props.client_list.filter((el) => el["account_type"] == "leadgen").map((item) => item);
    const leadgenClients = leadgenList.map((item) => item.client_name);
    const ecommerceList = this.props.client_list.filter((el) => el["account_type"] == "ecommerce").map((item) => item);
    const ecommerceClients = ecommerceList.map((item) => item.client_name);
    let totals = {
      leadgen: {},
      ecommerce: {},
    };

    leadgenClients.map((client) => {
      metrics.map((metricName) => {
        let mValue = this.props.metrics[client][metricName];
        totals["leadgen"][metricName] ? (totals["leadgen"][metricName] += mValue) : (totals["leadgen"][metricName] = mValue);
      });
    });

    ecommerceClients.map((client) => {
      metrics.map((metricName) => {
        let mValue = this.props.metrics[client][metricName];
        totals["ecommerce"][metricName] ? (totals["ecommerce"][metricName] += mValue) : (totals["ecommerce"][metricName] = mValue);
      });
    });

    totals["leadgen"]["rev_or_conv_yy"] =
      ((totals["leadgen"]["rev_or_conv"] - totals["leadgen"]["rev_or_conv_ly"]) / totals["leadgen"]["rev_or_conv_ly"]) * 100;
    totals["leadgen"]["rev_or_conv_lm_yy"] =
      ((totals["leadgen"]["rev_or_conv_lm"] - totals["leadgen"]["rev_or_conv_lmly"]) / totals["leadgen"]["rev_or_conv_lmly"]) * 100;
    totals["ecommerce"]["rev_or_conv_yy"] =
      ((totals["ecommerce"]["rev_or_conv"] - totals["ecommerce"]["rev_or_conv_ly"]) / totals["ecommerce"]["rev_or_conv_ly"]) * 100;
    totals["ecommerce"]["rev_or_conv_lm_yy"] =
      ((totals["ecommerce"]["rev_or_conv_lm"] - totals["ecommerce"]["rev_or_conv_lmly"]) / totals["ecommerce"]["rev_or_conv_lmly"]) * 100;

    const changeTable = (table) => {
      this.setState({ activeTable: table });
    };
    return (
      <>
        <div className={"summary-buttons"}>
          <div>
            <p>Client Type:</p>
          </div>
          <div className="sb-container">
            <button
              className={this.state.activeTable == "ecommerce" ? "summary-button active" : "summary-button inactive"}
              onClick={() => {
                changeTable("ecommerce");
              }}>
              Ecommerce
            </button>
          </div>
          <div className="sb-container">
            <button
              className={this.state.activeTable == "leadgen" ? "summary-button active" : "summary-button inactive"}
              onClick={() => {
                changeTable("leadgen");
              }}>
              Lead Gen
            </button>
          </div>
        </div>
        <div className="row styled-indent-blue">
          <div className="col-12 pt-1 pl-md-3 pl-0">
            <div className="no-gutters clear-both off-color-bg show px-md-4 px-2 px-md-0 pt-md-4 pt-0 pb-md-4 pb-1">
              <div className="mb-2 table-responsive">
                {this.state.activeTable == "ecommerce" ? (
                  <Table className="mt-2 table-white table-striped table-striped-summary metric-table">
                    <thead>
                      <tr>
                        <th className="client-cell client-head">Client</th>
                        {this.props.metric_list.map((metric) => {
                          return (
                            <th className="client-head" key={metric.display_name}>
                               {metric.display_name == "Revenue or Conversions" ? "Revenue" :
                                metric.display_name == "Revenue or Conversions Y/Y" ? "Revenue Y/Y" :
                                metric.display_name == "Revenue or Conversions Y/Y Last Month" ? "Revenue Y/Y Last Month" :
                                metric.display_name}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {ecommerceList.map((client) => {
                        return (
                          <tr key={client.client_name}>
                            <td className="client-cell" style={{ textAlign: "left", fontWeight: "900" }}>
                              {client.client_name}
                            </td>
                            {this.props.metric_list.map((metric) => {
                              let value = this.props.metrics[client.client_name][metric.programmatic_name];
                              let prefix = "";
                              let suffix = "";
                              let precision = 0;
                              let commas = true;
                              let className = false;
                              if (metric.programmatic_name.includes("yy")) {
                                suffix = "%";
                                precision = 0;
                                className = value > 0 ? "bg-success" : "bg-danger ";
                              } else if (metric.programmatic_name.includes("rev_or_conv")) {
                                prefix = "$";
                              } else if (metric.programmatic_name.includes("proj_to_budget")) {
                                prefix = "$";
                                className = value > 0 ? "bg-danger" : "bg-success";
                              } else if (metric.programmatic_name.includes("proj_to_kpi_goal")) {
                                prefix = "$";
                                precision = 2;
                                className = value > 0 ? "bg-success" : "bg-danger";
                              } else if (metric.programmatic_name.includes("kpi_goal")) {
                                prefix = "$";
                                precision = 2;
                              } else {
                                prefix = "$";
                              }

                              return (
                                <td key={metric.programmatic_name} className={className ? className + " text-white" : ""}>
                                  <Metric value={value} prefix={prefix} suffix={suffix} precision={precision} commas={commas} />
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                      <tr>
                        <td className="client-cell totals-row" style={{ textAlign: "left", fontWeight: "900" }}>
                          TOTALS
                        </td>
                        {this.props.metric_list.map((metric) => {
                          let value = totals["ecommerce"][metric.programmatic_name];
                          let prefix = "";
                          let suffix = "";
                          let precision = 0;
                          let commas = true;
                          let className = false;

                          if (metric.programmatic_name.includes("yy")) {
                            suffix = "%";
                            precision = 0;
                            className = value > 0 ? "bg-success" : "bg-danger";
                            className =  value == 0 || value == Infinity || value == -Infinity ? "" : className;
                            suffix =  value == 0 || value == Infinity || value == -Infinity ? "" : suffix;
                          } else if (metric.programmatic_name.includes("rev_or_conv")) {
                            prefix = "$";
                          } else if (metric.programmatic_name.includes("proj_to_budget")) {
                            prefix = "$";
                            className = value > 0 ? "bg-danger" : "bg-success";
                          } else if (metric.programmatic_name.includes("proj_to_kpi_goal")) {
                            prefix = "$";
                            precision = 2;
                            className = value > 0 ? "bg-success" : "bg-danger";
                          } else if (metric.programmatic_name.includes("kpi_goal")) {
                            prefix = "$";
                            precision = 2;
                          } else {
                            prefix = "$";
                          }

                          return (
                            <td key={metric.programmatic_name} className={className ? className + " text-white totals-row" : " totals-row"}>
                              <Metric value={value} prefix={prefix} suffix={suffix} precision={precision} commas={commas} />
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </Table>
                ) : (
                  <Table className="mt-2 table-white table-striped table-striped-summary metric-table">
                    <thead>
                      <tr>
                        <th className="client-cell client-head">Client</th>
                        {this.props.metric_list.map((metric) => {
                          return (
                            <th className="client-head" key={metric.display_name}>
                               {metric.display_name == "Revenue or Conversions" ? "Conversions" :
                                metric.display_name == "Revenue or Conversions Y/Y" ? "Conversions Y/Y" :
                                metric.display_name == "Revenue or Conversions Y/Y Last Month" ? "Conversions Y/Y Last Month" :
                                metric.display_name}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {leadgenList.map((client) => {
                        return (
                          <tr key={client.client_name}>
                            <td className="client-cell" style={{ textAlign: "left", fontWeight: "900" }}>
                              {client.client_name}
                            </td>
                            {this.props.metric_list.map((metric) => {
                              let value = this.props.metrics[client.client_name][metric.programmatic_name];
                              let prefix = "";
                              let suffix = "";
                              let precision = 0;
                              let commas = true;
                              let className = false;

                              if (metric.programmatic_name.includes("yy")) {
                                suffix = "%";
                                precision = 0;
                                className = value > 0 ? "bg-success" : "bg-danger";
                              } else if (metric.programmatic_name.includes("rev_or_conv")) {
                                prefix = "";
                              } else if (metric.programmatic_name.includes("proj_to_budget")) {
                                prefix = "$";
                                className = value > 0 ? "bg-danger" : "bg-success";
                              } else if (metric.programmatic_name.includes("proj_to_kpi_goal")) {
                                prefix = "$";
                                precision = 2;
                                className = value > 0 ? "bg-danger" : "bg-success";
                              } else if (metric.programmatic_name.includes("kpi_goal")) {
                                prefix = "$";
                                precision = 2;
                              } else {
                                prefix = "$";
                              }

                              return (
                                <td key={metric.programmatic_name} className={className ? className + " text-white" : ""}>
                                  <Metric value={value} prefix={prefix} suffix={suffix} precision={precision} commas={commas} />
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                      <tr>
                        <td className="client-cell totals-row" style={{ textAlign: "left", fontWeight: "900" }}>
                          TOTALS
                        </td>
                        {this.props.metric_list.map((metric) => {
                          let value = totals["leadgen"][metric.programmatic_name];
                          let prefix = "";
                          let suffix = "";
                          let precision = 0;
                          let commas = true;
                          let className = false;

                          if (metric.programmatic_name.includes("yy")) {
                            suffix = "%";
                            precision = 0;
                            className = value > 0 ? "bg-success" : "bg-danger";
                            className =  value == 0 || value == Infinity || value == -Infinity ? "" : className;
                            suffix =  value == 0 || value == Infinity || value == -Infinity ? "" : suffix;
                          } else if (metric.programmatic_name.includes("rev_or_conv")) {
                            prefix = "";
                          } else if (metric.programmatic_name.includes("proj_to_budget")) {
                            prefix = "$";
                            className = value > 0 ? "bg-danger" : "bg-success";
                          } else if (metric.programmatic_name.includes("proj_to_kpi_goal")) {
                            prefix = "$";
                            precision = 2;
                            className = value > 0 ? "bg-danger" : "bg-success";
                          } else if (metric.programmatic_name.includes("kpi_goal")) {
                            prefix = "$";
                            precision = 2;
                          } else {
                            prefix = "$";
                          }

                          return (
                            <td key={metric.programmatic_name} className={className ? className + " text-white totals-row" : " totals-row"}>
                              <Metric value={value} prefix={prefix} suffix={suffix} precision={precision} commas={commas} />
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </Table>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PPCSummaryDisplay;
